import { asyncComponent } from '@wkda/after-framework';
import { NotFoundRedirect } from '@wkda/funnel-components';
import './styles.scss';

const routes = [
  {
    path: `/`,
    exact: true,
    component: asyncComponent({
      loader: () => import('./pages/step1'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
    aboveTheFoldLoader: async ({ loadRelativeS3File, log }) => {
      try {
        return await loadRelativeS3File('inspection-above-the-fold.css');
      } catch (err) {
        log.error('[AboveTheFold] failed for inspection page');
      }
    },
  },
  {
    path: `/step-2`,
    exact: true,
    component: asyncComponent({
      loader: () => import('./pages/step2'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
    aboveTheFoldLoader: async ({ loadRelativeS3File, log }) => {
      try {
        return await loadRelativeS3File('inspection-above-the-fold.css');
      } catch (err) {
        log.error('[AboveTheFold] failed for inspection page');
      }
    },
  },
  {
    path: `/step-1`,
    exact: true,
    component: asyncComponent({
      loader: () => import('./pages/step2'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
    aboveTheFoldLoader: async ({ loadRelativeS3File, log }) => {
      try {
        return await loadRelativeS3File('inspection-above-the-fold.css');
      } catch (err) {
        log.error('[AboveTheFold] failed for inspection page');
      }
    },
  },
  {
    // there is no need to declare path variable
    // react router will pick this component as fallback
    component: NotFoundRedirect,
  },
];

export default routes;
